import { Box, Button, Card, Link, Typography } from "@mui/material";

function App() {
  return (
    <Box
      sx={{
        backgroundColor: "rgb(10, 17, 51)",
        height: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          pb: 20,
          boxSizing: "border-box",
          maxWidth: "100%",
          m: 1,
        }}
      >
        <Box
          sx={{
            maxWidth: "100%",
            padding: 1,
            boxSizing: "border-box",
          }}
        >
          <Card
            sx={{
              backgroundColor: "rgb(19, 32, 94)",
              maxWidth: "100%",
              px: { xs: 2, sm: 12, md: 12 },
              py: { xs: 8, sm: 8, md: 12 },
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              color: "#FFF",
              boxSizing: "border-box",
              borderRadius: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                boxSizing: "border-box",
                p: 1,
              }}
            >
              <img src="/liquid.svg" width={300} />
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                justifyItems: "center",
                alignItems: "center",
                p: 1,
                textAlign: "center",
                flexDirection: "column",
                maxWidth: 400,
              }}
            >
              <Typography
                sx={{
                  my: 4,
                }}
              >
                Liquid (Quoine PTE) customer accounts are now fully managed
                through the FTX Claims portal.
                <br />
                <br />
                Please follow the link below to login to the claims portal, and
                choose "Liquid" from the drop down menu.
              </Typography>
              <Link href="https://claims.ftx.com">
                <Button
                  sx={{
                    textTransform: "none",
                    color: "#a1c4e8",
                    borderColor: "#73b1ef",
                    textDecoration: "underline",
                  }}
                  variant="outlined"
                  size="large"
                >
                  https://claims.ftx.com
                </Button>
              </Link>
              <Typography
                sx={{
                  mt: 4,
                  fontSize: 12,
                }}
              >
                © 2025, Quoine Pte. Ltd. (UEN 201414068E) All Rights Reserved.
              </Typography>
            </Box>
          </Card>
        </Box>
      </Box>
    </Box>
  );
}

export default App;
